import Base from "../core/Base"

const UserDashBoard = () => {
    return ( 
        <Base title ="UserDashBoard Page">
            <h1>This is Userdashboard Page</h1>
        </Base>
     );
}
 
export default UserDashBoard;